export interface SharedParameterDefinition {
    guid: string;
    name: string;
    type: string;
    group: string;
    visible: boolean;
    description?: string;
}

export class SharedParameterRegistry {
    private definitions: Map<string, SharedParameterDefinition> = new Map(); // By GUID
    private nameIndex: Map<string, string> = new Map(); // Name -> GUID

    constructor() {
        // Load default shared parameters (Mocking a loaded file)
        this.loadDefaults();
    }

    private loadDefaults() {
        this.register({
            guid: 'a1b2c3d4-e5f6-7890-1234-567890abcdef',
            name: 'FireRating',
            type: 'Text',
            group: 'Identity Data',
            visible: true
        });
        this.register({
            guid: 'b2c3d4e5-f678-9012-3456-7890abcdef12',
            name: 'Manufacturer',
            type: 'Text',
            group: 'Identity Data',
            visible: true
        });
    }

    register(def: SharedParameterDefinition) {
        this.definitions.set(def.guid, def);
        this.nameIndex.set(def.name, def.guid);
    }

    getByGuid(guid: string): SharedParameterDefinition | undefined {
        return this.definitions.get(guid);
    }

    getByName(name: string): SharedParameterDefinition | undefined {
        const guid = this.nameIndex.get(name);
        if (guid) return this.definitions.get(guid);
        return undefined;
    }

    /**
     * "Parses" a BIM Shared Parameter text file format (mock)
     */
    importFromText(content: string) {
        const lines = content.split('\n');
        lines.forEach(line => {
            if (line.startsWith('#') || !line.trim()) return;
            // Mock Format: GUID \t NAME \t DATATYPE \t GROUP \t VISIBLE
            const parts = line.split('\t');
            if (parts.length >= 4) {
                this.register({
                    guid: parts[0],
                    name: parts[1],
                    type: parts[2],
                    group: parts[3],
                    visible: parts[4] === '1'
                });
            }
        });
    }
}

export const sharedParameterRegistry = new SharedParameterRegistry();
